export type ChapterRange = {
  top: number;
  bottom: number;
};

export type JourneyPosition = {
  activeIndex: number;
  progress: number;
};

const clamp01 = (value: number) => Math.max(0, Math.min(1, value));

export function locateJourney(viewportCentre: number, ranges: ChapterRange[]): JourneyPosition {
  if (ranges.length === 0) return { activeIndex: 0, progress: 0 };

  const first = ranges[0];
  const last = ranges[ranges.length - 1];
  const distance = Math.max(1, last.bottom - first.top);
  const progress = clamp01((viewportCentre - first.top) / distance);
  let activeIndex = 0;

  for (let index = 0; index < ranges.length; index += 1) {
    if (viewportCentre >= ranges[index].top) activeIndex = index;
    if (viewportCentre < ranges[index].bottom) break;
  }

  return { activeIndex, progress };
}
